export default __webpack_public_path__ + "static/media/harvard_university_logo.bf439ea8.png";